import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Settings, Activity, FileText, FolderTree, Database, Terminal, TrendingUp } from 'lucide-react';
import ServicesTab from './ServicesTab';
import TaskManagerTab from './TaskManagerTab';
import EventViewerTab from './EventViewerTab';
import ComingSoonTab from './ComingSoonTab';
import RemoteTerminalTab from './RemoteTerminalTab';
import FileExplorerTab from './FileExplorerTab';
import PerformanceMonitor from './PerformanceMonitor';

const ToolsTab = ({ agentId }) => {
  const [activeTool, setActiveTool] = useState('performance');

  const toolItems = [
    { id: 'performance', label: 'Performance', icon: TrendingUp },
    { id: 'services', label: 'Services', icon: Settings },
    { id: 'taskmanager', label: 'Task Manager', icon: Activity },
    { id: 'eventviewer', label: 'Event Viewer', icon: FileText },
    { id: 'terminal', label: 'Terminal', icon: Terminal },
    { id: 'registry', label: 'Registry', icon: Database },
    { id: 'fileexplorer', label: 'File Explorer', icon: FolderTree }
  ];

  const renderToolContent = () => {
    switch (activeTool) {
      case 'performance':
        return <PerformanceMonitor agentId={agentId} />;
      case 'services':
        return <ServicesTab agentId={agentId} />;
      case 'taskmanager':
        return <TaskManagerTab agentId={agentId} />;
      case 'eventviewer':
        return <EventViewerTab agentId={agentId} />;
      case 'terminal':
        return <RemoteTerminalTab agentId={agentId} />;
      case 'registry':
        return (
          <ComingSoonTab
            title="Registry Editor"
            features={[
              'Browse registry keys',
              'Edit registry values',
              'Search registry',
              'Export/Import registry files',
              'Real-time registry monitoring'
            ]}
          />
        );
      case 'fileexplorer':
        return <FileExplorerTab agentId={agentId} />;
      default:
        return <ServicesTab agentId={agentId} />;
    }
  };

  return (
    <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 overflow-hidden">
      {/* Left Sidebar Menu - Stacks on mobile, sidebar on desktop */}
      <div className="w-full lg:w-64 flex-shrink-0">
        <Card>
          <CardHeader className="pb-3 lg:pb-6">
            <CardTitle className="text-base">System Tools</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <nav className="flex lg:flex-col lg:space-y-1 overflow-x-auto lg:overflow-x-visible">
              {toolItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => setActiveTool(item.id)}
                    className={`flex-shrink-0 lg:w-full flex items-center gap-2 lg:gap-3 px-3 lg:px-4 py-2 lg:py-3 text-left transition-colors whitespace-nowrap ${
                      activeTool === item.id
                        ? 'bg-blue-50 text-blue-700 border-b-4 lg:border-b-0 lg:border-r-4 border-blue-600'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <Icon className="w-4 h-4 lg:w-5 lg:h-5" />
                    <span className="font-medium text-sm lg:text-base">{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </CardContent>
        </Card>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 min-w-0 overflow-auto">
        {renderToolContent()}
      </div>
    </div>
  );
};

export default ToolsTab;
